import * as React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { StepContainer, StepLayouts } from '@ane/ui-components/lib/components/StepContainer';
import { CreateStepTitle } from '../CreateWizard/CreateSteps';
import { FormHeading } from '@ane/ui-components/lib/components/FormHeading';
import { FormSection } from '@ane/ui-components/lib/components/FormSection';
import { ExternalLink } from '@ane/ui-components/lib/components/ExternalLink';
import { DetailsListWithCommandBar } from '@ane/ui-components/lib/components/DetailsList/DetailsListWithCommandBar';
import { SelectionMode, Selection, Accordion } from '@ane/ui-components';
import { IconButton, Stack } from '@ane/ui-components';
import { CheckboxField } from '@ane/ui-components/lib/components/FormikFormFields/CheckboxField';
import { loadDataSourceFlightFormatsEpicReducer, } from '../../ducks/DataSourceFlightFormats.ducks';
import _ from 'lodash';
import { SpecialColumnsField } from './SpecialColumnsField';
import SpecialColumnsDropdown from './SpecialColumnsDropdown';
import { useEffect, useRef } from 'react';
import { showNGPColumnsInSpecialColumn } from '../../utils/DataSourceFormikSettingsUtils';
export const SpecialColumnsComponent = (props) => {
    var _a;
    const flightFormats = (_a = useSelector((state) => state.dataSourceManagementModule.dataSourceFlightFormats.items.data)) !== null && _a !== void 0 ? _a : [];
    const selectionRandomizationUnit = useRef(new Selection());
    const selectionFlight = useRef(new Selection());
    const selectionTimestamp = useRef(new Selection());
    const dispatch = useDispatch();
    useEffect(() => {
        dispatch(loadDataSourceFlightFormatsEpicReducer.actionCreators.load({
            workspaceId: props.workspaceId,
            dataSourceType: props.storageType ? props.storageType : 'Cosmos',
        }));
    }, [props.workspaceId, props.storageType, props.loadDataSourceFlightFormats, dispatch]);
    const _onRenderUnmanagedList = (key, name, listName, errorMessages, list, selection, columns, defaultValue, onRenderColumn, dropdownList) => {
        const items = [];
        items.push({
            key: `Add-${key}`,
            ariaLabel: `Add ${name.toLowerCase()}`,
            disabled: !!props.isReadOnly,
            iconProps: {
                iconName: 'Add',
            },
            name: `Add ${name.toLowerCase()}`,
            onClick: () => {
                var _a;
                let newList = [...(list ? list : []), defaultValue];
                (_a = props.setFieldValue) === null || _a === void 0 ? void 0 : _a.call(props, listName, newList, true);
            },
        });
        items.push({
            key: `Delete-${key}`,
            ariaLabel: `Delete ${name.toLowerCase()}`,
            disabled: !!props.isReadOnly || list.length <= 0,
            iconProps: {
                iconName: 'Delete',
            },
            name: 'Delete',
            onClick: () => {
                var _a;
                const index = selection.getSelectedIndices();
                if (index.length <= 0)
                    return;
                let newList = [];
                if (list) {
                    newList = [...list.slice(0, index[0]), ...list.slice(index[0] + 1)];
                }
                (_a = props.setFieldValue) === null || _a === void 0 ? void 0 : _a.call(props, listName, newList, true);
            },
        });
        return (React.createElement(Accordion, { ariaLabel: name, header: name, showContentOnRender: true },
            React.createElement(DetailsListWithCommandBar, { commandBarProps: { ariaLabel: `action items for ${name.toLowerCase()}`, items: items }, errors: errorMessages, detailsListProps: {
                    ariaLabelForGrid: 'Special columns unmanaged list',
                    selection: selection,
                    selectionMode: SelectionMode.single,
                    onRenderItemColumn: (item, index, column) => onRenderColumn === null || onRenderColumn === void 0 ? void 0 : onRenderColumn(key, listName, !!props.isReadOnly, list, index, column, dropdownList),
                    items: list ? list : [],
                    columns: columns,
                    defaultSortColumn: '',
                    disableSort: true,
                    checkButtonAriaLabel: `${name} row checkbox`,
                } })));
    };
    const _onRenderFlightListItemColumn = (key, listName, isReadOnly, list, index, column, dropdownList) => {
        const { fieldName = '' } = column || {};
        if (!column || !fieldName || index === undefined)
            return null;
        const ndropdownList = _genFlightFormatsList(list[index]);
        return _onRenderUnmanagedListItemColumn(key, listName, isReadOnly, list, index, column, ndropdownList);
    };
    const _onRenderTimeStampItemColumn = (key, listName, isReadOnly, list, index, column, dropdownList) => {
        const { fieldName = '' } = column || {};
        if (!column || !fieldName || index === undefined)
            return null;
        return (React.createElement(Stack, { tokens: { childrenGap: 10 } },
            React.createElement(SpecialColumnsField, { ariaLabel: listName, fieldName: `${listName}.[${index}].${fieldName}`, textFieldProps: {
                    isReadOnly: isReadOnly,
                } }),
            React.createElement(CheckboxField, { disabled: isReadOnly, styles: { text: { whiteSpace: 'normal' } }, name: `${listName}.[${index}].NonNullable`, ariaLabel: "I agree to allow this column type to be set as non-nullable.", onRenderLabel: () => (React.createElement("span", null,
                    "I agree to allow this column type to be set as non-nullable.",
                    ' ',
                    React.createElement(ExternalLink, { rel: "noopener noreferrer", text: "Learn more", "aria-label": 'Learn more about "Non-Nullable"', href: "https://eng.ms/docs/products/experimentation-platform/docs/datasources/datacontract#timestamp-column", target: "_blank" }))) })));
    };
    // Render item column for unmanagedList
    const _onRenderUnmanagedListItemColumn = (key, listName, isReadOnly, list, index, column, dropdownList) => {
        const { fieldName = '' } = column || {};
        if (!column || !fieldName || index === undefined)
            return null;
        switch (fieldName) {
            case 'Format':
                return (React.createElement(SpecialColumnsDropdown, { index: index, fieldName: `${listName}.[${index}].Format`, formatOptions: dropdownList ? dropdownList : [], dropdownProps: {
                        isReadOnly: isReadOnly,
                    } }));
            default:
                return (React.createElement(SpecialColumnsField, { ariaLabel: listName, fieldName: `${listName}.[${index}].${fieldName}`, textFieldProps: {
                        isReadOnly: isReadOnly,
                    } }));
        }
    };
    // Flight Column dropdown
    const _genFlightFormatsList = (currentFlight) => {
        let options = [];
        let source = null;
        const flightFormatList = [...flightFormats];
        if ((currentFlight === null || currentFlight === void 0 ? void 0 : currentFlight.Definition) && (currentFlight === null || currentFlight === void 0 ? void 0 : currentFlight.Source) && (currentFlight === null || currentFlight === void 0 ? void 0 : currentFlight.Example)) {
            if (!flightFormats.map((item) => item.Example).includes(currentFlight.Example)) {
                flightFormatList === null || flightFormatList === void 0 ? void 0 : flightFormatList.push({
                    Source: currentFlight.Source,
                    Definition: currentFlight.Definition,
                    Example: currentFlight.Example,
                });
            }
        }
        _.each(flightFormatList, (item, key) => {
            if (source === null || source !== item.Source) {
                source = item.Source;
                options.push({
                    key: `${key} Header`,
                    text: source !== null && source !== void 0 ? source : '',
                    itemType: 2,
                    data: { Source: '', Definition: '', Example: '' },
                });
                options.push({
                    key: item.Example,
                    text: item.Example,
                    data: {
                        Source: item.Source,
                        Definition: item.Definition,
                        Example: item.Example,
                    },
                });
            }
            else if (source === item.Source) {
                options.push({
                    key: item.Example,
                    text: item.Example,
                    data: {
                        Source: item.Source,
                        Definition: item.Definition,
                        Example: item.Example,
                    },
                });
            }
        });
        return options;
    };
    const { randomizationListErrors, flightListErrors, timestampListErrors } = props;
    const randomizationErrors = typeof randomizationListErrors === 'string' ? [randomizationListErrors] : [];
    const flightErrors = typeof flightListErrors === 'string' ? [flightListErrors] : [];
    const timestampErrors = typeof timestampListErrors === 'string' ? [timestampListErrors] : [];
    const columns = [
        {
            key: 'ColumnName',
            name: 'Column name',
            maxWidth: 280,
            minWidth: 280,
            fieldName: 'ColumnName',
            data: 'string',
        },
    ];
    if (showNGPColumnsInSpecialColumn(props.storageType)) {
        const ngpColumns = [
            {
                key: 'NGPColumnTag',
                name: 'NGP column tag code annotation',
                minWidth: 300,
                maxWidth: 500,
                fieldName: 'NGPColumnTag',
                data: 'string',
                onRenderHeader: (column) => {
                    var _a;
                    return (React.createElement("div", null, (_a = column === null || column === void 0 ? void 0 : column.column.name) !== null && _a !== void 0 ? _a : '',
                        React.createElement(IconButton, { calloutProps: {
                                content: `For example: [Privacy.Subject.User.ObjectId(Column=#ColumnName#, Format=Privacy.Subject.User.ObjectId.AllowedFormat.Guid)]`,
                            }, iconProps: { iconName: 'Info' }, ariaLabel: " NGP column tag Info" })));
                },
                onRender: (item, index) => {
                    return (React.createElement(SpecialColumnsField, { ariaLabel: 'NGP column tag', fieldName: `randomizationList.[${index}].NGPColumnTag`, required: false, textFieldProps: {
                            isReadOnly: false,
                            description: 'Provide the NGP column tag',
                        } }));
                },
            },
            {
                key: 'NGPStreamTag',
                name: 'NGP stream tag code annotation',
                minWidth: 300,
                maxWidth: 500,
                fieldName: 'NGPStreamTag',
                data: 'string',
                onRenderHeader: (column) => {
                    var _a;
                    return (React.createElement("div", null, (_a = column === null || column === void 0 ? void 0 : column.column.name) !== null && _a !== void 0 ? _a : '',
                        React.createElement(IconButton, { calloutProps: {
                                content: `For example: [Privacy.Asset.IntermediateEngineering]`,
                            }, iconProps: { iconName: 'Info' }, ariaLabel: "NGP stream tag Info" })));
                },
                onRender: (item, index) => (React.createElement(SpecialColumnsField, { ariaLabel: 'NGP stream tag', fieldName: `randomizationList.[${index}].NGPStreamTag`, required: false, textFieldProps: {
                        isReadOnly: false,
                        description: 'Provide the NGP stream tag',
                    } })),
            },
        ];
        columns.push(...ngpColumns);
    }
    return (React.createElement(StepContainer, { layout: StepLayouts.fullWidth },
        !props.isUpdateDataSource && (React.createElement(FormHeading, { pageTitle: CreateStepTitle.SpecialColumns }, "This is where you specify at least one assignment unit column, one flight column along with its format, and one timestamp column.")),
        React.createElement(FormSection, null,
            _onRenderUnmanagedList('assignment unit columns', 'Assignment unit column(s)', 'randomizationList', randomizationErrors, props.randomizationList, selectionRandomizationUnit.current, columns, {
                ColumnName: '',
                NGPColumnTag: '',
                NGPStreamTag: '',
            }, _onRenderUnmanagedListItemColumn),
            _onRenderUnmanagedList('flight columns', 'Variant column(s)', 'flightList', flightErrors, props.flightList, selectionFlight.current, [
                {
                    key: 'ColumnName',
                    name: 'Column name',
                    minWidth: 280,
                    maxWidth: 280,
                    fieldName: 'ColumnName',
                    data: 'string',
                },
                {
                    key: 'Format',
                    name: 'Format',
                    minWidth: 280,
                    fieldName: 'Format',
                    data: 'string',
                },
            ], {
                ColumnName: '',
                Format: '',
                Source: '',
                Definition: '',
                Example: '',
            }, _onRenderFlightListItemColumn),
            _onRenderUnmanagedList('timestamp columns', 'Timestamp column(s)', 'timestampList', timestampErrors, props.timestampList, selectionTimestamp.current, [
                {
                    key: 'ColumnName',
                    name: 'Column name',
                    minWidth: 280,
                    fieldName: 'ColumnName',
                    data: 'string',
                },
            ], {
                ColumnName: '',
                NonNullable: false,
            }, _onRenderTimeStampItemColumn))));
};
export default SpecialColumnsComponent;

//# sourceMappingURL=SpecialColumnsComponent.js.map
